export default "__VITE_ASSET__DOBO5T7D__"